const BASE_URL = import.meta.env.VITE_API_URL ?? "http://localhost:8080";
const TOKEN_KEY = "nifgash.session";

// Hydrate from localStorage on module load so refresh keeps the user signed in.
let sessionToken: string | null = typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;

export function setSession(token: string | null) {
  sessionToken = token;
  if (typeof localStorage === "undefined") return;
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getSession(): string | null {
  return sessionToken;
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (sessionToken) headers.set("Authorization", `Bearer ${sessionToken}`);
  const isFormData = init?.body instanceof FormData;
  if (init?.body && !isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(`${BASE_URL}${path}`, { ...init, headers });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    // 401 means the JWT is gone or invalid — drop it so the UI can re-auth.
    if (res.status === 401) setSession(null);
    throw new Error(`api ${path} ${res.status}: ${text}`);
  }
  return (await res.json()) as T;
}
